"use strict";

export const ajaxFormClass = class {
  container = false;
  loading = false;

  constructor(container) {
    if (!container) {
      return false;
    }
    this.container = container;

    this._init();
    return this;
  }

  _init = () => {
    const {
      container,
      _loading,
      _send,
      _clearErrorsInForm,
      _showHideFormElement,
    } = this;

    $(container).off();

    _showHideFormElement();

    $(container).on("submit", (event) => {
      event.preventDefault();
      _loading(true);
      _clearErrorsInForm();
      _send();
      return false;
    });
  };

  _send = () => {
    const {
      container,
      _loading,
      _displayErrorsInForm,
      _displayMsgInForm,
      _showReturnInfo,
    } = this;
    let formData = new FormData(container);

    formData.append(
      $(container).find(":submit").attr("name"),
      $(container).find(":submit").val()
    );

    let request = $.ajax({
      url: $(container).attr("action"),
      method: "POST",
      data: formData,
      processData: false,
      contentType: false,
      cache: false,
    });

    request.done((returnInfo) => {
      const returnData = JSON.parse(returnInfo);

      if (returnData.msg) {
        _displayMsgInForm(returnData.msg);
      }
      if (returnData.data && returnData.data.errors) {
        _displayErrorsInForm(returnData.data.errors);
      }

      _showReturnInfo(returnData.status, returnData.msg);
    });

    request.fail((jqXHR, textStatus) => {
      console.log(jqXHR, textStatus);
      _showReturnInfo(false, []);
    });

    request.always(() => {
      //_loading(false);
    });
  };

  _loading = (status) => {
    const { container, _loadingContainer } = this;

    if (status) {
      let isLoading = $("body").find(".form-loading-container");
      if (isLoading.length > 0) return false;
      $("body").append(_loadingContainer());
    } else {
      $("body").find(".form-loading-container").remove();
    }
  };

  _showReturnInfo = (status, msg) => {
    const { container, _loading, _returnInfoContainer } = this;

    let isLoading = $("body").find(".form-loading-container");
    if (isLoading.length == 0) return false;

    $(isLoading[0]).html(_returnInfoContainer(status, msg));

    $("body")
      .find(".form-return-button--error")
      .on("click", (event) => {
        event.preventDefault();
        _loading(false);
        return false;
      });

    $("body")
      .find(".form-return-button--ok")
      .on("click", (event) => {
        event.preventDefault();
        _loading(false);
        $(container)[0].reset();
        return false;
      });
  };

  _displayMsgInForm = (msg) => {
    const { container } = this;
    [...msg].forEach((element) => {
      $(container).prepend(
        `<p class="form-msg form-msg--${element.type}">${element.text}</p>`
      );
    });
  };

  _displayErrorsInForm = (errors) => {
    const { container } = this;
    for (const property in errors) {
      const elm = $(container).find("[name=" + property + "]");
      const elmAlternative = $(container).find("[name=" + property + "\\[\\]]");
      if (elm.length > 0) {
        let parents = $(elm[0]).parents("div");
        if (parents.length == 0) return;

        $(parents[0]).addClass("error");
        $(parents[0]).append(
          `<p class="form-error-msg">${errors[property]}</p>`
        );
      }
      if (elmAlternative.length > 0) {
        let parents = $(elmAlternative[0]).parents("div");
        if (parents.length == 0) return;

        $(parents[0]).addClass("error");
        $(parents[0]).append(
          `<p class="form-error-msg">${errors[property]}</p>`
        );
      }
    }
  };

  _clearErrorsInForm = () => {
    const { container } = this;

    $(container).find(".form-msg").remove();
    $(container).find(".form-error-msg").remove();
    $(container).find(".error").removeClass("error");
    $(container).find(".zalaczniki-list").html("");
  };

  _svgMailIcon = () => {
    return '<svg viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg" class="svg-mail-icon"> <path d="M232.183,201.642L76.512,201.642C64.314,201.642 54.389,191.717 54.389,179.518L54.389,150.969C54.389,148.642 56.275,146.754 58.604,146.754C60.934,146.754 62.819,148.642 62.819,150.969L62.819,179.518C62.819,187.069 68.962,193.212 76.512,193.212L232.183,193.212C239.734,193.212 245.877,187.066 245.877,179.518L245.877,76.195C245.877,68.644 239.731,62.502 232.183,62.502L76.512,62.502C68.962,62.502 62.819,68.644 62.819,76.195L62.819,104.402C62.819,106.731 60.934,108.617 58.604,108.617C56.275,108.617 54.389,106.731 54.389,104.402L54.389,76.195C54.389,63.997 64.314,54.072 76.512,54.072L232.183,54.072C244.382,54.072 254.307,63.997 254.307,76.195L254.307,179.518C254.307,191.717 244.382,201.642 232.183,201.642ZM180.494,127.857L227.494,84.74C229.208,83.166 229.323,80.5 227.752,78.783C226.178,77.069 223.515,76.956 221.798,78.527L154.346,140.406L86.901,78.527C85.184,76.956 82.52,77.069 80.944,78.783C79.37,80.497 79.485,83.166 81.199,84.74L128.199,127.857L81.199,170.976C79.485,172.552 79.37,175.216 80.944,176.93C81.775,177.838 82.911,178.296 84.052,178.296C85.069,178.296 86.092,177.928 86.901,177.186L134.435,133.575L151.497,149.229C152.301,149.968 153.324,150.339 154.346,150.339C155.369,150.339 156.392,149.968 157.196,149.229L174.261,133.575L221.798,177.186C222.607,177.928 223.627,178.296 224.647,178.296C225.785,178.296 226.923,177.838 227.752,176.93C229.326,175.216 229.21,172.55 227.494,170.976L180.494,127.857ZM36.523,161.532L13.754,161.532C11.424,161.532 9.539,159.643 9.539,157.317C9.539,154.99 11.424,153.102 13.754,153.102L36.526,153.102C38.855,153.102 40.741,154.99 40.741,157.317C40.741,159.643 38.853,161.532 36.523,161.532ZM72.845,132.072L22.591,132.072C20.262,132.072 18.376,130.186 18.376,127.857C18.376,125.527 20.262,123.642 22.591,123.642L72.848,123.642C75.178,123.642 77.063,125.527 77.063,127.857C77.063,130.186 75.175,132.072 72.845,132.072ZM36.523,102.612L5.622,102.612C3.292,102.612 1.407,100.726 1.407,98.397C1.407,96.067 3.292,94.182 5.622,94.182L36.523,94.182C38.853,94.182 40.738,96.067 40.738,98.397C40.738,100.726 38.853,102.612 36.523,102.612Z" /></svg>';
  };

  _svgMailFailIcon = () => {
    return '<svg viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg" class="svg-mail-fail-icon"> <path d="M232.183,201.642L76.512,201.642C64.314,201.642 54.389,191.717 54.389,179.518L54.389,150.969C54.389,148.642 56.275,146.754 58.604,146.754C60.934,146.754 62.819,148.642 62.819,150.969L62.819,179.518C62.819,187.069 68.962,193.212 76.512,193.212L232.183,193.212C239.734,193.212 245.877,187.066 245.877,179.518L245.877,76.195C245.877,68.644 239.731,62.502 232.183,62.502L76.512,62.502C68.962,62.502 62.819,68.644 62.819,76.195L62.819,104.402C62.819,106.731 60.934,108.617 58.604,108.617C56.275,108.617 54.389,106.731 54.389,104.402L54.389,76.195C54.389,63.997 64.314,54.072 76.512,54.072L232.183,54.072C244.382,54.072 254.307,63.997 254.307,76.195L254.307,179.518C254.307,191.717 244.382,201.642 232.183,201.642ZM180.494,127.857L227.494,84.74C229.208,83.166 229.323,80.5 227.752,78.783C226.178,77.069 223.515,76.956 221.798,78.527L154.346,140.406L86.901,78.527C85.184,76.956 82.52,77.069 80.944,78.783C79.37,80.497 79.485,83.166 81.199,84.74L128.199,127.857L81.199,170.976C79.485,172.552 79.37,175.216 80.944,176.93C81.775,177.838 82.911,178.296 84.052,178.296C85.069,178.296 86.092,177.928 86.901,177.186L134.435,133.575L151.497,149.229C152.301,149.968 153.324,150.339 154.346,150.339C155.369,150.339 156.392,149.968 157.196,149.229L174.261,133.575L221.798,177.186C222.607,177.928 223.627,178.296 224.647,178.296C225.785,178.296 226.923,177.838 227.752,176.93C229.326,175.216 229.21,172.55 227.494,170.976L180.494,127.857ZM36.523,161.532L13.754,161.532C11.424,161.532 9.539,159.643 9.539,157.317C9.539,154.99 11.424,153.102 13.754,153.102L36.526,153.102C38.855,153.102 40.741,154.99 40.741,157.317C40.741,159.643 38.853,161.532 36.523,161.532ZM72.845,132.072L22.591,132.072C20.262,132.072 18.376,130.186 18.376,127.857C18.376,125.527 20.262,123.642 22.591,123.642L72.848,123.642C75.178,123.642 77.063,125.527 77.063,127.857C77.063,130.186 75.175,132.072 72.845,132.072ZM36.523,102.612L5.622,102.612C3.292,102.612 1.407,100.726 1.407,98.397C1.407,96.067 3.292,94.182 5.622,94.182L36.523,94.182C38.853,94.182 40.738,96.067 40.738,98.397C40.738,100.726 38.853,102.612 36.523,102.612Z" /></svg>';
  };

  _svgMailOkIcon = () => {
    return '<svg viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg" class="svg-mail-ok-icon"> <path d="M232.183,201.642L76.512,201.642C64.314,201.642 54.389,191.717 54.389,179.518L54.389,150.969C54.389,148.642 56.275,146.754 58.604,146.754C60.934,146.754 62.819,148.642 62.819,150.969L62.819,179.518C62.819,187.069 68.962,193.212 76.512,193.212L232.183,193.212C239.734,193.212 245.877,187.066 245.877,179.518L245.877,76.195C245.877,68.644 239.731,62.502 232.183,62.502L76.512,62.502C68.962,62.502 62.819,68.644 62.819,76.195L62.819,104.402C62.819,106.731 60.934,108.617 58.604,108.617C56.275,108.617 54.389,106.731 54.389,104.402L54.389,76.195C54.389,63.997 64.314,54.072 76.512,54.072L232.183,54.072C244.382,54.072 254.307,63.997 254.307,76.195L254.307,179.518C254.307,191.717 244.382,201.642 232.183,201.642ZM180.494,127.857L227.494,84.74C229.208,83.166 229.323,80.5 227.752,78.783C226.178,77.069 223.515,76.956 221.798,78.527L154.346,140.406L86.901,78.527C85.184,76.956 82.52,77.069 80.944,78.783C79.37,80.497 79.485,83.166 81.199,84.74L128.199,127.857L81.199,170.976C79.485,172.552 79.37,175.216 80.944,176.93C81.775,177.838 82.911,178.296 84.052,178.296C85.069,178.296 86.092,177.928 86.901,177.186L134.435,133.575L151.497,149.229C152.301,149.968 153.324,150.339 154.346,150.339C155.369,150.339 156.392,149.968 157.196,149.229L174.261,133.575L221.798,177.186C222.607,177.928 223.627,178.296 224.647,178.296C225.785,178.296 226.923,177.838 227.752,176.93C229.326,175.216 229.21,172.55 227.494,170.976L180.494,127.857ZM36.523,161.532L13.754,161.532C11.424,161.532 9.539,159.643 9.539,157.317C9.539,154.99 11.424,153.102 13.754,153.102L36.526,153.102C38.855,153.102 40.741,154.99 40.741,157.317C40.741,159.643 38.853,161.532 36.523,161.532ZM72.845,132.072L22.591,132.072C20.262,132.072 18.376,130.186 18.376,127.857C18.376,125.527 20.262,123.642 22.591,123.642L72.848,123.642C75.178,123.642 77.063,125.527 77.063,127.857C77.063,130.186 75.175,132.072 72.845,132.072ZM36.523,102.612L5.622,102.612C3.292,102.612 1.407,100.726 1.407,98.397C1.407,96.067 3.292,94.182 5.622,94.182L36.523,94.182C38.853,94.182 40.738,96.067 40.738,98.397C40.738,100.726 38.853,102.612 36.523,102.612Z" /></svg>';
  };

  _loadingContainer = () => {
    const { _svgMailIcon } = this;
    return `<div class="form-loading-container"><div class="form-loading__center"><div class="form-loading__icon--sending">${_svgMailIcon()}</div><div class="form-loading__progress-bar"></div><div class="form-loading__label">wysyłanie wiadomości</div></div></div>`;
  };

  _returnInfoContainer = (status, msg) => {
    const { _svgMailFailIcon, _svgMailOkIcon } = this;

    let container = `<div class="form-return-info-container ${
      status
        ? "form-return-info-container--ok"
        : "form-return-info-container--error"
    }">`;
    container += '<div class="form-return-info__center">';
    container += `<div class="form-return-info__icon">${
      status ? _svgMailOkIcon() : _svgMailFailIcon()
    }</div>`;
    container += `<h2 class="form-return-info__header">${
      status
        ? askFormLangs.formularz_ok_title
        : askFormLangs.formularz_error_title
    }</h2>`;
    container += '<div class="form-return-info__msg-container">';
    [...msg].forEach((element) => {
      container += `<p class="form-msg form-msg--${element.type}">${element.text}</p>`;
    });
    container += "</div>";
    container += '<div class="form-return-info__buttons-container">';
    container += `<a class="form-return-button form-return-button--${
      status ? "ok" : "error"
    }"><span class="front">${
      status
        ? askFormLangs.formularz_btn_do_strony
        : askFormLangs.formularz_btn_do_formularza
    }</span><span class="back"></span></a>`;
    container += "</div>";
    container += "</div>";
    container += "</div>";

    return container;
  };

  _showHideFormElement = () => {
    const { container } = this;
    const elm = $(container).find(".hide-form-element");
    $(elm).each(function (index) {
      let element = elm[index];
      $(element).hide();
      let dataShowName = $(element).attr("data-show-name");
      let dataShowValue = $(element).attr("data-show-value");

      let dataShowElement = $(container).find("[name=" + dataShowName + "]");

      if ($(this).val() == dataShowValue) {
        $(element).show();
      }

      $(dataShowElement).on("change", function (event) {
        event.preventDefault();
        let val = $(this).val();
        if (val == dataShowValue) {
          $(element).show();
        } else {
          $(element).hide();
        }

        return false;
      });
    });
  };
};
